export default {
    props: {
        pannableKey: {
            type: String,
            default: undefined,
            kComposite: 'pannable.key'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-diagram-vue-wrapper/src/KendoDiagram/Pannable.js